export default __webpack_public_path__ + "media/images/ui-bg_highlight-soft_100_eeeeee_1x100-e61f2c0c8fcb00498f21b2f3db1e3208.png";